<template>
  <div class="topUser">
    <div class="user-line">
            <div class="system-title">晓家碧寓内部员工系统{{ currentModelName==null||currentModelName==''?'':'-'+currentModelName }}</div>
            <div class="user" @click="userButtonGroup=!userButtonGroup">
                <div class="user-logo">
                    <img src="@/assets/images/logo_user.png" alt="">
                </div>
                <div class="user-text">{{ userInfo.username }}</div>
                <div class="dropdown-content" v-show="userButtonGroup" @click="backToHome"> 返回主页 </div>
                <div class="dropdown-content" v-show="userButtonGroup" @click="exit" style="margin-top: 50px;"> 退出登录 </div>
            </div>
        
      </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name:"topUserV2",
  props:{
     currentModelName:{
        type:String,
        default:""
    }
  },
  created(){
        this.initializeData()
            
    },
    computed: {
        ...mapState([ 'userInfo'])
  
    },
    data() {
        return {
          userButtonGroup:false,//用户操作按钮
        }
    },
    
    mounted(){   },
    watch:{},
    methods:{
      initializeData() { 

            // 检查 userInfo
            if (!this.userInfo || Object.keys(this.userInfo).length === 0) {
                this.$Message.error("未检测到用户信息，返回登录页");
                this.$router.push('/login'); // 跳转到登录页面
            } else {
               
            }
        },
        exit(){
           this.$store.commit('clearUserInfo'); // 调用 Vuex mutation
            this.$store.commit('clearToken'); // 调用 Vuex mutation
            this.$router.replace('/login');
        },
        backToHome(){
          this.$router.replace('/home');
        }
    }


}
</script>

  
  <style lang="scss" >
@import 'topUserV2.scss'; 

  </style>